<template>
  <div class="input auth-form-auto-complete">
    <Dropdown
      trigger="custom"
      :visible="visible">
      <input
        ref="input"
        type="text"
        :placeholder="placeholder"
        v-model="data"
        autocomplete="off"
        :disabled="disabled"
        :maxlength="maxlength"
        @keyup="keyup"
      />
      <DropdownMenu slot="list">
        <div
          v-for="item in filterData"
          :value="item"
          :key="item"
          class="ivu-select-item"
          @click="handleDropdownClick(item)"
        >
          <span>{{ item }}</span>
        </div>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import Schema from 'async-validator';
export default {
  name: 'AuthFormAutoComplete',
  props: {
    maxlength: Number,
    placeholder: {
      type: String,
    },
    rule: {
      type: [Object, Array],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchData: {
      type: Array,
      default: () => [],
    },
    value: [String, Number],
  },
  data() {
    return {
      data: '',
      visible: false,
      validator: null,
      filterData: [],
    };
  },
  watch: {
    searchData(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.filterData = n;
    },
    value(n, o) {
      const newVal = JSON.stringify(n);
      const oldVal = JSON.stringify(o);
      if (newVal === oldVal) return;
      this.data = n;
    },
  },
  methods: {
    check() {
      return new Promise((resolve, reject) => {
        this.validate().then(() => {
          this.$emit('validator', true);
          resolve(true);
        }, (msg) => {
          this.$emit('validator', msg);
          resolve(false);
        });
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.data}, (err) => {
          if (err) {
            reject(err[0].message);
          } else {
            resolve();
          }
        });
      });
    },
    keyup(e) {
      this.validate().then(() => {
        this.$emit('validator', true);
        if (e.keyCode == 13) {
          this.$emit('keyup-enter');
        }
      }, (msg) => {
        this.$emit('validator', msg);
      });
      this.$emit('input', this.data);
    },
    addEvent() {
      const input = this.$refs['input'];
      input.addEventListener('focus', this.focus);
      input.addEventListener('blur', this.blur);
      input.addEventListener('input', this.input);
    },
    removeEvent() {
      const input = this.$refs['input'];
      input.removeEventListener('focus', this.focus);
      input.removeEventListener('blur', this.blur);
      input.removeEventListener('input', this.input);
    },
    focus() {
      this.visible = this.filterData.length > 0;
      this.$emit('validator', true);
    },
    blur() {
      this.visible = false;
      this.validate().then(() => {
        this.$emit('validator', true);
      }, (msg) => {
        this.$emit('validator', msg);
      });
    },
    input() {
      this.filter();
      this.visible = this.filterData.length > 0;
    },
    filter() {
      if (this.data) {
        this.filterData = this.searchData.filter((item) => item.indexOf(this.data) !== -1);
      } else {
        this.filterData = this.searchData;
      }
    },
    handleDropdownClick(value) {
      this.data = value;
      this.filter();
      this.validate().then(() => {
        this.$emit('validator', true);
      }, (msg) => {
        this.$emit('validator', msg);
      });
    },
  },
  mounted() {
    this.addEvent();
    this.filterData = this.searchData;
  },
  beforeDestroy() {
    this.removeEvent();
  },
};
</script>

<style lang="scss">

.auth-form-auto-complete {
  .ivu-dropdown {
    width: 100%;
  }
  input {
    color: rgba(0,0,0,.45);
  }
  .ivu-dropdown .ivu-select-dropdown {
    overflow: auto;
    max-height: 200px;
    left: 0 !important;
  }
  .ivu-select-item {
    position: relative;
    i {
      position: absolute;
      top: 9px;
      right: 5px;
      color: #999;
      &:hover {
        color: rgba(7, 120, 248, 1);
      }
    }
  }
}
</style>
